import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';


const ResetPassword = () => {
    console.log("ResetPassword component rendered");

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [resetSent, setResetSent] = useState(false);
    const [resetCode, setResetCode] = useState("");
    const [error, setError] = useState(null);



    const sendReset = async (email) => {
        setResetSent(true);

        console.log("send_reset function called with email:", email);
        const response = await fetch("/api/user/requestReset", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }),
        });
        const json = await response.json();
        console.log("Response received:", json);

        if (!response.ok) {
            console.log("Reset email not sent");
            return;
        }
        if (response.ok) {
            console.log("Reset email sent successfully");

        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("handleSubmit function called");
        await sendReset(email);
    };

    const handleResetCodeSubmit = async (e) => {
        e.preventDefault();
        console.log(email)
        console.log(resetCode)
        const response = await fetch("/api/user/resetCodeSubmit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, resetCode }),
        });
        const json = await response.json();
        console.log("Response received:", json);

        if (!response.ok) {
            console.log("Code incorrect or timed out");
            return;
        }
        if (response.ok) {
            console.log("Reset email sent successfully");
            localStorage.setItem('email', email);

            navigate('/reset_password_continued')


        }
        // Add your logic to handle reset code submission here
    };

    return (
        <div className="login">
            <form onSubmit={handleSubmit}>
                <h3>Reset Password</h3>
                <label>Email:</label>
                <input
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                />
                <button type="submit" className="submit-button">
                    Submit
                </button>
            </form>
            {resetSent && (
                <form onSubmit={handleResetCodeSubmit}>
                    <h3>Enter Reset Code</h3>
                    <label>Reset Code:</label>
                    <input
                        type="text"
                        onChange={(e) => setResetCode(e.target.value)}
                        value={resetCode}
                        required
                    />
                <button type="submit" className="submit-button">
                    Submit
                </button>
                {error && <div className="error">{error}</div>}
            </form>
            )}

        </div>
    );
};

export default ResetPassword;